// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"96222b72","323":"bef2f8da","360":"827dea77","408":"2b80e9d0","453":"56f593cb","578":"e777f7a5","633":"0b6b9893","735":"f1d245c8","889":"308f9b42","905":"e8fb6eb7"}[chunkId] + ".chunk.js";
};